import React, { useState, useEffect } from 'react';
import { Button, AlertDialog, Select, Text, Flex, Box, Badge, Heading } from '@radix-ui/themes';
import { PlusIcon, Cross1Icon } from '@radix-ui/react-icons';
import api from '../../api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DAYS } from '../../utils/constants';
import { set } from 'lodash';
// Move these to a constants file


const ScheduleForm = ({ courses, fetchCourses, selectedCourse = {} }) => {
    const [schedules, setSchedules] = useState({});
    const [alertDay, setAlertDay] = useState(null);
    const [levels, setLevels] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(null);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [changes, setChanges] = useState({new:0, remove:0});
    const navigate = useNavigate();


    useEffect(() => {
        const initializeSchedules = () => {
            const groupedSchedules = courses.reduce((acc, course) => {
                course.schedules.forEach((schedule) => {
                    const day = DAYS[schedule.day];
                    if (!acc[day]) acc[day] = [];
                    acc[day].push({
                        ...course
                    });
                });
                return acc;
            }, {});
            console.log('grouped schedule', groupedSchedules)
            setSchedules(groupedSchedules);
        };

        if (courses?.length > 0) initializeSchedules();
    }, [courses]);


    useEffect(() => {
        const fetchLevelsAndSubjects = async () => {
            try {
                const [levelsResponse, subjectsResponse] = await Promise.all([
                    api.get('/levels'),
                    api.get('/subjects'),
                ]);
                setLevels(levelsResponse.data);
                setSubjects(subjectsResponse.data);
                console.log('levels response >>>>>>>>>>>>>>>>>>', levelsResponse)
            } catch (error) {
                console.error('Error fetching levels or subjects:', error);
            }
        };

        fetchLevelsAndSubjects();
    }, []);

    const updateChanges = () => {
        let newCount = 0;
        let removeCount = 0;

        Object.values(schedules).forEach((dayCourses) => {
            dayCourses.forEach((course) => {
                if (course.status === "new") newCount++;
                if (course.status === "remove") removeCount++;
            });
        });

        setChanges({ new: newCount, remove: removeCount });
    };

    useEffect(() => {
        updateChanges();
    }, [schedules]);

    const handleAddCourse = () => {
        if (!selectedLevel || !selectedSubject) return;
        addCourseToSchedule(parseInt(selectedSubject.id), parseInt(selectedLevel));
    };

    const handleAddExistingCourse = (course) => {
        addCourseToSchedule(course.subject.id, course.level.id);
    };

    const addCourseToSchedule = (subject_id, level_id) => {
        const existingCourses = schedules[alertDay] || [];
        const isDuplicate = existingCourses.some(
            (course) =>
                course.level.id === level_id &&
                course.subject.id === subject_id
        );

        if (isDuplicate) {
            toast.error("This class and subject combination already exists for this day", {
                position: "bottom-right",
            });
            return;
        }

        setSchedules((prev) => ({
            ...prev,
            [alertDay]: [
                ...(prev[alertDay] || []),
                {
                    subject: subjects.find((subject) => subject.id === subject_id),
                    level: levels.find((level) => level.id === level_id),
                    status: "new", // Mark as new
                },
            ],
        }));

        // Reset form
        setAlertDay(null);
        setSelectedLevel(null);
        setSelectedSubject(null);
    }

    const handleRemoveCourse = (day, index) => {
        const course = schedules[day][index]
        const updatedDayCourses = schedules[day];

        if(course.status == 'new'){
            updatedDayCourses.splice(index, 1);
        } else if (course.status == 'remove'){
            updatedDayCourses[index].status = 'active';
        } else {
            updatedDayCourses[index].status = 'remove';
        }

        setSchedules((prev) => ({
            ...prev,
            [day]: updatedDayCourses,
        }));
        updateChanges();
        
        // const updatedDayCourses = schedules[day];
        // const course = updatedDayCourses[index];
        // console.log('removing course', course.subject.name);
        // if(course.status == 'remove'){

        // }
        // setSchedules((prev) => {

            // const updatedDayCourses = prev[day].map((course, i) => {
            //     if (i === index) {
            //         if (course.status === "new") {
            //             return null;
            //         }

            //         if (course.status === "remove") {
            //             // Remove the 'status' field entirely
            //             const { status, ...rest } = course;
            //             return rest;
            //         }
            //         return { ...course, status: "remove" }; // Add 'status: "remove"'
            //     }
            //     return course;
            // });

            // return {
            //     ...prev,
            //     [day]: updatedDayCourses,
            // };
        // });
    };

    const handleSave = async () => {
        
        const relevantEntries = Object.entries(schedules).reduce((acc, [day, courses]) => {
            const filteredCourses = courses.filter(course => course.status === 'new' || course.status === 'remove');
            if (filteredCourses.length > 0) {
                acc.push(
                    { day:Object.keys(DAYS).find((key) => DAYS[key] === day), 
                        courses: filteredCourses.map((course) => ({
                            level_id: course.level.id,
                            subject_id: course.subject.id,
                            status: course.status, // Include status
                        }))
                    }
                );
            };
            return acc;
        }, []);

        console.log('relevant entries', relevantEntries);

        try {
            await api.post("/schedules", { schedules: relevantEntries });
            toast.success("Schedules updated successfully");
            fetchCourses()
        } catch (error) {
            toast.error(error.response.data.error || "Failed to update schedules. Please try again.");
            console.error("Error updating schedules:", error);
        }
    };

    // Render helper function for course items
    const renderCourseItem = (course, day, index) => {
        // console.log('course', course);
        return(
        <Button
            key={`${day}-${course.subject.id}-${course.level.id}`}
            size="1"
            variant="soft"
            style={{
                border: course.id == selectedCourse?.id ? '2px solid var(--accent-8)' : course.status == 'new' ? '2px dashed var(--gray-6)' : 'none',
                backgroundColor: course.status == 'new' ? 'var(--gray-3)' : course.status == 'remove' ? 'var(--red-5)' : 'var(--accent-5)',
            }}
        >
            <Text size="1" className='flex-1'>
                {course.level.label} | {course.subject.name}
            </Text>
            <Cross1Icon
                className='cursor-pointer'
                onClick={() => handleRemoveCourse(day, index)}
            />
        </Button>
    )};

    return (
        <div>
                <Flex direction="column" gap="2">
                    <Flex gap="2" justify="between" align="center">
                        <Heading size="3">Schedule</Heading>
                    {(changes.new > 0 || changes.remove > 0) && 
                        <Flex gap="2" align="center">
                            <Flex gap="2" align="center">
                                {changes.new > 0 && <Badge color="green">+ {changes.new}</Badge>}
                                {changes.remove > 0 && <Badge color="orange">- {changes.remove}</Badge>}
                            </Flex>
                            <Button onClick={handleSave} color="green">
                                Save
                            </Button>
                        </Flex>
                        }
                    </Flex>
                {Object.values(DAYS).map(day => (
                    <Flex key={day} gap="2" py="3" style={{ borderBottom: '1px solid var(--gray-6)' }}>
                        <Flex justify="center">
                            <Button
                                gap="2"
                                size="1"
                                weight="normal"
                                style={{ width: '100px', justifyContent: 'space-between' }}
                                onClick={() => setAlertDay(day)}
                            >
                                <Text size="1">{day}</Text>
                                <PlusIcon />
                            </Button>
                        </Flex>

                        <Flex gap="2" className='flex flex-wrap'>
                            {schedules[day]?.map((course, index) =>
                                renderCourseItem(course, day, index)
                            )}
                        </Flex>
                    </Flex>
                ))}
            </Flex>

            <AlertDialog.Root open={!!alertDay} onOpenChange={(open) => !open && setAlertDay(null)}>
                <AlertDialog.Content>
                    <AlertDialog.Title>Add Course for {alertDay}</AlertDialog.Title>
                    <Flex direction="row" gap="4">
                        {courses.length > 0 && (
                            <Flex direction="column" gap="4" style={{ maxWidth: '40%' }}>
                                {courses.map((course) => (
                                    <Flex direction="row" py="1" justify="between" align="center" gap="4" key={course.id} style={{ cursor: 'pointer', borderBottom: '1px solid var(--gray-6)'}}
                                        onClick={() => handleAddExistingCourse(course)}
                                    >
                                        <Text size="1" as="p">{course.subject.name} - {course.level.label}</Text>
                                        <PlusIcon />
                                    </Flex>
                                ))}
                            </Flex>
                        )}
                        <Flex direction="column" gap="4" style={{ flex: 1 }}>
                            <Heading size="1">Add New Course</Heading>
                            <Select.Root
                                value={selectedLevel}
                                onValueChange={(value) => {
                                    setSelectedLevel(value);
                                }}
                            >
                                <Select.Trigger>
                                    {selectedLevel
                                        ? levels.find((level) => level.id === parseInt(selectedLevel))?.label
                                        : 'Select Level'}
                                </Select.Trigger>
                                <Select.Content>
                                    {levels.map((level) => (
                                        <Select.Item key={level.id} value={level.id.toString()}>
                                            {level.label}
                                        </Select.Item>
                                    ))}
                                </Select.Content>
                            </Select.Root>

                            <Select.Root
                                value={selectedSubject?.id?.toString()}
                                onValueChange={(value) => {
                                    setSelectedSubject(subjects.find((subject) => subject.id === parseInt(value)));
                                }}
                                disabled={!selectedLevel}
                            >
                                <Select.Trigger>
                                    {selectedSubject
                                        ? selectedSubject.name
                                        : 'Select Subject'}
                                </Select.Trigger>
                                <Select.Content>
                                    {subjects.map((subject) => (
                                        <Select.Item key={subject.id} value={subject.id.toString()}>
                                            {subject.name}
                                        </Select.Item>
                                    ))}
                                </Select.Content>
                            </Select.Root>
                        </Flex>
                    </Flex>
                    <Flex justify="end" gap="3" mt="4">
                        <Button
                            onClick={handleAddCourse}
                            disabled={!selectedLevel || !selectedSubject}
                            color="green"
                        >
                            Save
                        </Button>
                        <Button variant="soft" onClick={() => setAlertDay(null)}>
                            Cancel
                        </Button>
                    </Flex>
                </AlertDialog.Content>
            </AlertDialog.Root>
        </div>
    );
};

export default ScheduleForm;
